@if (isVisible()) {
    <div
        #checklistElement
        class="onboarding-checklist"
        [class.minimized]="isMinimized()"
        [class.dragging]="isDragging"
        [style.left.px]="dragPosition().x"
        [style.top.px]="dragPosition().y">
        <div class="checklist-header">
            <div class="header-content">
                <div class="header-title">
                    <div class="drag-handle" (mousedown)="onDragStart($event)" title="Drag to move">
                        <i class="bi bi-grip-vertical"></i>
                    </div>
                    <i class="bi bi-rocket-takeoff me-2"></i>
                    <h5 class="mb-0">Getting Started</h5>
                </div>
                <div class="header-actions">
                    <button class="btn btn-sm btn-link p-0 me-2" (click)="toggleMinimize()" title="Minimize">
                        <i [class]="isMinimized() ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </button>
                    <button class="btn btn-sm btn-link p-0" (click)="dismiss()" title="Dismiss">
                        <i class="bi bi-x-lg"></i>
                    </button>
                </div>
            </div>

            <div class="progress-overview">
                <div class="progress-stats">
                    <span class="completed-count">{{ progress().completedItems }}</span>
                    <span class="separator">/</span>
                    <span class="total-count">{{ progress().totalItems }}</span>
                    <span class="progress-label">completed</span>
                </div>
                <div class="progress-bar-wrapper">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [style.width.%]="progress().percentageComplete"
                            [attr.aria-valuenow]="progress().percentageComplete"
                            aria-valuemin="0"
                            aria-valuemax="100"></div>
                    </div>
                    <span class="progress-percentage">{{ progress().percentageComplete }}%</span>
                </div>
            </div>
        </div>

        @if (!isMinimized()) {
            <div class="checklist-body">
                @for (category of categories(); track category.name) {
                    <div class="category-section">
                        <div
                            class="category-header"
                            [class.active]="activeCategory() === category.name"
                            (click)="toggleCategory(category.name)">
                            <div class="category-info">
                                <i
                                    class="bi"
                                    [class.bi-chevron-right]="activeCategory() !== category.name"
                                    [class.bi-chevron-down]="activeCategory() === category.name">
                                </i>
                                <span class="category-name">{{ category.name }}</span>
                                <span class="category-count"
                                    >({{ getCompletedCount(category.items) }}/{{ category.items.length }})</span
                                >
                            </div>
                            @if (category.completed) {
                                <i class="bi bi-check-circle-fill text-success"></i>
                            }
                        </div>

                        @if (activeCategory() === category.name) {
                            <div class="category-items">
                                @for (item of category.items; track item.id) {
                                    <div class="checklist-item" [class.completed]="item.completed">
                                        <div class="item-checkbox">
                                            <input
                                                type="checkbox"
                                                [id]="item.id"
                                                [checked]="item.completed"
                                                (change)="toggleItem(item)"
                                                class="form-check-input" />
                                        </div>
                                        <div class="item-content" (click)="navigateToItem(item)">
                                            <div class="item-icon">
                                                <i class="bi bi-{{ item.icon }}"></i>
                                            </div>
                                            <div class="item-details">
                                                <h6 class="item-title">{{ item.title }}</h6>
                                                <p class="item-description">{{ item.description }}</p>
                                            </div>
                                        </div>
                                        @if (item.route && !item.completed) {
                                            <button
                                                class="btn btn-sm btn-outline-primary item-action"
                                                (click)="navigateToItem(item)">
                                                Start
                                            </button>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>

            @if (progress().percentageComplete === 100) {
                <div class="completion-celebration">
                    <div class="celebration-content">
                        <i class="bi bi-trophy-fill text-warning"></i>
                        <h5>Congratulations!</h5>
                        <p>You've completed all onboarding tasks. You're all set!</p>
                        <button sfButton color="success" (click)="dismiss()">Dismiss Checklist</button>
                    </div>
                </div>
            }
        }
    </div>
}
